const memoize = (fn: any) => {
    const cache = new Map<string, any>()
    return (...args: any[]) => {
        const key = JSON.stringify(args)
        if (!cache.has(key)) {
            cache.set(key, fn(...args))
        }
        return cache.get(key)
    }
}

export default memoize
